import { Link } from "wouter";
import { Navbar } from "@/components/layout/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Services } from "@/components/sections/Services";
import { Pricing } from "@/components/sections/Pricing";
import { Contact } from "@/components/sections/Contact";
import { ChatWidget } from "@/components/chat/ChatWidget";
import { useAuth } from "@/contexts/AuthContext";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Shield } from "lucide-react";
import { HomeSEO } from "@/components/SEO";
import { MainContent } from "@/components/MainContent";

export default function Home() {
  const { isAdmin } = useAuth();

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <HomeSEO />
      <Navbar />
      {isAdmin && (
        <div className="fixed top-16 left-0 right-0 z-40 px-6 py-3">
          <Alert className="border-primary/50 bg-primary/10">
            <Shield className="h-4 w-4" />
            <AlertTitle>Admin Test Mode Active</AlertTitle>
            <AlertDescription>
              You are logged in as an admin. You can test builds without payment requirements.
              Visit the <Link href="/admin/builder" className="underline font-medium">Admin Builder</Link> to create test builds.
            </AlertDescription>
          </Alert>
        </div>
      )}
      <MainContent className={isAdmin ? "pt-24" : ""}>
        <Hero />
        <Services />
        <Pricing />
        <Contact />
      </MainContent>
      
      <footer className="py-8 text-center text-muted-foreground border-t border-white/5 bg-background/50 backdrop-blur-sm">
        <p>© 2025 AI Systems Studio. All rights reserved.</p>
      </footer>
      
      <ChatWidget />
    </div>
  );
}
